import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile')
    }
})

const exampleStory = {
    id: 0,
    name: 'A story name',
    events: [
        {
            id: 1,
            type: 'say',
            text: "You walk through a beautiful forest when you suddenly hear something buzzing. It's a honeycomb! You develop a sudden craving for honey."
        },
        {
            id: 2,
            type: 'decision',
            decision: 'You decide to grab the honeycomb from the tree.'
        },
        {
            id: 3,
            type: 'ask',
            question: 'Do I grab the honeycomb succesfully?',
            answer: 'No, and...'
        },
        {
            id: 4,
            type: 'say',
            text: 'Unamused by the sudden intrustion the bees buzz out to see what all the ruckus is about. If there is anything you know about bees, is that they don\'t take kindly to humans.They aggressively storm towards you.'
        },
        {
            id: 5,
            type: 'say',
            text: "You desperately try to swat the bees away from you."
        },
        {
            id: 6,
            type: 'roll',
            Result: 1,
            Dice: [
                {
                    Faces: 6,
                    Result: 1
                },
            ]
        },
        {
            id: 7,
            type: 'say',
            text: "But it has no effect. But just before you are about to die from beestings you are rescued by a brave..."
        },
        {
            id: 8,
            type: 'gimme',
            generator: 'NPC',
            text: 'German Shepherd'
        }
    ]
}

const state = {
    currentUser: null,
    userProfile: {},
    activeStory: null,
}

const mutations = {
    addSay(state, payload) {
        if(!state.activeStory) {
            return
        }

        let events = [...state.activeStory.events]
        payload.id = new Date().getTime()
        events.push(payload)

        Vue.set(state.activeStory, 'events', events)
    },
    addRoll(state, payload) {
        let events = [...state.activeStory.events]
        payload.id = new Date().getTime()
        events.push(payload)

        Vue.set(state.activeStory, 'events', events)
    },
    setCurrentUser(state, val) {
        state.currentUser = val
    },
    setUserProfile(state, val) {
        state.userProfile = val
    },
    openStory(state, val) {
        state.activeStory = val
    }
}

const actions = {
    addSay({commit}, payload) {
        commit('addSay', payload)
    },
    addRoll({commit}) {
        Axios
            .get('https://us-central1-cloud-gm-zargon.cloudfunctions.net/roll')
            .then(response => {
                let payload = response.data
                payload.type = 'roll'
                commit('addRoll', payload)
            })
    },
    fetchUserProfile() {
        
    },
    clearData({ commit }) {
        commit('setCurrentUser', null)
        commit('setUserProfile', {})
    },
    createNewStory({ commit }) {
        var newStory = exampleStory
        newStory.owner = state.currentUser.uid

        commit('openStory', newStory)
    },
    openStory({ commit }, payload) {
        commit('openStory', payload)
    },
    saveActiveStory() {
        var doc = null
        if(state.activeStory.id) {
            doc = fb.storiesCollection.doc(state.activeStory.id)
        } else {
            doc = fb.storiesCollection.doc()
        }

        doc.set(state.activeStory)
            .then(function(docRef) {
                console.log(docRef)
            })
            .catch(function(error) {
                console.log(error)
            })
    }
}

const store = new Vuex.Store({
    state: state,
    actions: actions,
    mutations: mutations
})
export default store
